export default __webpack_public_path__ + "media/images/placeholder_acm-183d44c1780c9e61a0ad3cdaed269dfc.png";